import React, { useEffect } from 'react'
import { Table } from '@imcva/reactstrap-table'
import { Columns } from './columns'
import { useCardContext } from 'src/components/Card/CardContext'
import { useStaffingAgencyPocs } from 'src/queries'

interface CardBodyProps {
  columns: Columns
  staffingAgency: string
}

const Body: React.FC<CardBodyProps> = (props) => {
  const { columns, staffingAgency } = props
  const pocs = useStaffingAgencyPocs({
    filter: {
      staffingAgency
    }
  })
  const card = useCardContext()
  const count = pocs.length
  useEffect(() => {
    card.setTitle(`Points of Contact (${String(count)})`)
  }, [count])
  return (
    <Table storageKey='staffingAgency-pocs' options={{ data: pocs, columns, initialState: { sorting: [{ id: 'name', desc: false }] } }} />
  )
}

export default Body
